import type { ILogger } from '@cian/logger';

interface IDependencies {
  logger: ILogger;
}

const FALLBACK = '*';

export function prepareOrigin(dependencies: IDependencies, url: string) {
  if (!url) {
    return FALLBACK;
  }

  try {
    const parsedUrl = new URL(url);

    return `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.port ? `:${parsedUrl.port}` : ''}`;
  } catch (ex) {
    dependencies.logger.warning(ex, { domain: 'browser.common.prepareOrigin' });
  }

  return FALLBACK;
}
